import { useContext } from 'react';
import { AppMenuContext } from '../context/AppMenuContext';

const useMenu = () => {
  return useContext(AppMenuContext);
};

export default useMenu;
